<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <div class="col-lg-6">
          <span class="p-float-label w-100 mb-3">
            <p-dropdown class="w-100" [options]="countries" formControlName="toMobileCtry" optionLabel="name"
            optionValue="dial" placeholder="Country Code"></p-dropdown>
            <label for="Country Code">Country Code</label>
            @for (validation of validationMessages.toMobileCtry; track validation) {
              <span>
                @if (form1.get('toMobileCtry').hasError(validation.type) && (form1.get('toMobileCtry').dirty || form1.get('toMobileCtry').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-6">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="toMobile" id="toMobile" type="text" pInputText>
            <label for="toMobile">To Phone Number</label>
            @for (validation of validationMessages.toMobile; track validation) {
              <span>
                @if (form1.get('toMobile').hasError(validation.type) && (form1.get('toMobile').dirty || form1.get('toMobile').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-12">
          <span class="p-float-label w-100 mb-3">
            <textarea formControlName="smsMessage" id="smsMessage" [rows]="2" pInputTextarea></textarea>
            <label for="smsMessage">SMS Message</label>
            @for (validation of validationMessages.smsMessage; track validation) {
              <span>
                @if (form1.get('smsMessage').hasError(validation.type) && (form1.get('smsMessage').dirty || form1.get('smsMessage').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

      </div>
    </div>
    <hr>
      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              <!-- <button pButton *ngIf="employeeProfileId" class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete</button> -->
          </div>

          <div class="button-group">
            <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>

            <button pButton class="btn-addt p-button" (click)="formAdd()">Send</button>
          </div>

          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>

          <button pButton class="btn-addt p-button" (click)="formAdd()">Send</button>
        </div>
      </div>
    </div>
  </div>